import React from 'react'

import { ToggleFieldWithLabel } from '@components/Form/Fields'

import {
  totalIncomeFromInvestments,
} from '@utils/assets'

import {
  totalNetIncomeAtAge,
  totalAdditionalIncomeFromInvestmentsAtAge,
  totalMonthlyCashflowIncomeAtAge
} from '@utils/forecast'

import { R } from '@utils/currency'

export const CurrentIncomeBreakdown = ({ participantsQueries, config, jointForecast }) => {
  const tableData = participantsQueries.reduce((acc, participantQuery) => {
    const clientName = participantQuery.participant.name
    const clientId = participantQuery.participant.id
    const grossIncome = participantQuery.budget.data.gross_monthly_current_income

    const clientForecast = jointForecast.client_forecasts[`client_${clientId}`]


    const incomeFromAssets = totalIncomeFromInvestments(participantQuery.assets.data, config.supportedCurrencies)
    const additionalIncomeFromAssets = totalAdditionalIncomeFromInvestmentsAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )
    const totalNetIncome = totalNetIncomeAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )

    const cashflowIncome = totalMonthlyCashflowIncomeAtAge(
      clientForecast,
      participantQuery.participant.currentAge
    )

    return {
      ...acc,
      totals: {
        grossIncome: acc.totals.grossIncome + grossIncome,
        incomeFromAssets: acc.totals.incomeFromAssets + incomeFromAssets,
        additionalIncomeFromAssets: acc.totals.additionalIncomeFromAssets + additionalIncomeFromAssets,
        totalNetIncome: acc.totals.totalNetIncome + totalNetIncome,
        cashflowIncome: acc.totals.cashflowIncome + cashflowIncome
      },
      participantData: [...acc.participantData, {
        clientName,
        grossIncome,
        incomeFromAssets,
        additionalIncomeFromAssets,
        totalNetIncome,
        cashflowIncome
      }]
    }
  },
    {
      participantData: [],
      totals: {
        grossIncome: 0,
        incomeFromAssets: 0,
        additionalIncomeFromAssets: 0,
        totalNetIncome: 0,
        cashflowIncome: 0
      }
    })

  return (
    <>
      <ToggleFieldWithLabel
        // onChange={submitForm}
        // readOnly={readOnly}
        style={{ marginTop: '0', marginBottom: '0' }}
        label='Surplus income should automatically be invested into assets'
        name='invest_surplus'
        tooltip='Surplus income from salary for the year should be re-invested into discretionary assets.'
      />
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Gross income</th>
            <th>Income from assets</th>
            <th>Additional income drawn from assets</th>
            <th>Total net income</th>
          </tr>
        </thead>
        <tbody>
          {tableData.participantData.map((participantData) =>
            <tr>
              <td>{participantData.clientName}</td>
              <td>{R(participantData.grossIncome).format()}</td>
              <td>{R(participantData.incomeFromAssets).format()}</td>
              <td>{R(participantData.additionalIncomeFromAssets).format()}</td>
              <td>
                <span>{R(participantData.totalNetIncome).format()}</span><br />
                <small>{R(participantData.cashflowIncome).format()} from cashflow income</small>
              </td>
            </tr>
          )}
          <tr>
            <td></td>
            <td><b>{R(tableData.totals.grossIncome).format()}</b></td>
            <td><b>{R(tableData.totals.incomeFromAssets).format()}</b></td>
            <td><b>{R(tableData.totals.additionalIncomeFromAssets).format()}</b></td>
            <td><b>{R(tableData.totals.totalNetIncome).format()}</b></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
